/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * <pre><code>Represents different types of users
 * SYSTEM is one userType
 * Any regular internal\/external user is not specifically represented
 * <\/code><\/pre>
 **/
export var UserType;
(function (UserType) {
    UserType["SYSTEM"] = "SYSTEM";
})(UserType || (UserType = {}));
